import { store } from 'store';
import { UPDATE_ENTIDAD_INFO } from 'store/reducers/auth';
import API from 'utils/api';
import getFormattedValues, { hasFiles } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'catalogos/entidades/';
const files = ['logotipo'];
const headers = { 'Content-Type': 'multipart/form-data' };

/**
 * POST Entidad
 * @param {object} params
 * @returns {Promise<Object>}
 */
export const postEntidad = async (values = {}) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.post(baseURI, formattedValues, config);
    onSuccess(response, 'Información actualizada correctamente');
    store.dispatch({
      type: UPDATE_ENTIDAD_INFO,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Entidad
 * @param {object} params
 * @returns {Promise<Object>}
 */
export const patchEntidad = async (values = {}) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.patch(baseURI, formattedValues, config);
    onSuccess(response, 'Información actualizada correctamente');
    store.dispatch({
      type: UPDATE_ENTIDAD_INFO,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Entidad
 * @param {object} params
 * @returns {Promise<Object>}
 */
export const getEntidad = async () => {
  try {
    const response = await API.get(baseURI);
    store.dispatch({
      type: UPDATE_ENTIDAD_INFO,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return {};
  }
};
